import * as fromDatatype from '../datatype-library/index';

export class app_psnl_menu_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_sort_method: fromDatatype.VarcharDatatypeInterface;
  obj_sort_code: fromDatatype.VarcharDatatypeInterface;
  name_full: fromDatatype.VarcharDatatypeInterface;
  name_short: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  visibility_scope: fromDatatype.VarcharDatatypeInterface;
  layout_json: any;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
}

export class app_psnl_menu_template_hdr_RowClass implements app_psnl_menu_template_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_sort_method: fromDatatype.VarcharDatatypeInterface;
  obj_sort_code: fromDatatype.VarcharDatatypeInterface;
  name_full: fromDatatype.VarcharDatatypeInterface;
  name_short: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.VarcharDatatypeInterface;
  visibility_scope: fromDatatype.VarcharDatatypeInterface;
  layout_json: any;
  tenant_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: any;
  acl_config: any;
  acl_policy: any;
}